const RoundedImg = (props) => {
  return (
    <div className="col-lg-5">
      <div className="img-holder">
        <img src={props.img} alt="" className="img-fluid heroImg" />
      </div>
    </div>
  );
};

export default RoundedImg;
